import { dotIcon } from "../../asset";
import { QueryItem, QueryTimeline } from "../../types/Query";

export default function QueryTimeLine({ data }: { data: QueryItem }) {
  const timelines: QueryTimeline[] = data.queryTimelines || [];

  if (!timelines.length) {
    return (
      <div className="bg-white py-5 px-4 md:px-6 max-w-72 w-full">
        <h3 className="text-xl font-semibold text-neutral-400">
          Query Timeline
        </h3>
        <p className="text-sm text-neutral-300 mt-4">No activity yet</p>
      </div>
    );
  }

  return (
    <div className="bg-white py-5 px-4 md:px-6 max-w-72 w-full flex flex-col gap-5">
      <h3 className="text-xl font-semibold text-neutral-400">Query Timeline</h3>

      <div className="relative flex flex-col">
        {timelines.map((item, index) => (
          <div key={item.id} className="flex gap-4 relative">
            <div className="flex flex-col items-center mt-1 shrink-0">
              <img src={dotIcon} alt="dot" className="w-4 h-4 z-10" />
              {index !== timelines.length - 1 && (
                <div className="w-px h-14 bg-neutral-50" />
              )}
            </div>

            <div>
              <p className="text-sm font-medium text-neutral-400">
                {item.actionTitle}
                {item.actionDescription && (
                  <span className="text-primary-600 font-semibold ml-1">
                    {item.actionDescription}
                  </span>
                )}
              </p>
              <p className="text-xs text-success-600 font-medium">
                {new Date(item.actionTime).toLocaleString()}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
